import { Card, Col, Container, Image, Row, Button } from 'react-bootstrap';
import userProfileImg from '../../admin-candidate/candiate-info-nav/img/avatar.png';
import './userProfile.css';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faListCheck, faPen, faSave } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef } from 'react';
import { UserService } from '../../../../services/userService';
import { useState } from 'react';
import { decodeJWT } from '../../../../services/candidateService';
import { useLocation } from 'react-router-dom';
import { serverConfig } from '../../../../services/server-config';
import axios from 'axios';
import { useProfileImage } from './profileImageContext';

export const UserProfile = () => {
  const [user, setUser] = useState({});
  const { profileImageUrl, setProfileImageUrl, fetchProfileImage, setLoading } = useProfileImage();
  const [emailId, setEmailId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [editState, setEditState] = useState({});
  const [profilePicUrl, setProfilePicUrl] = useState(userProfileImg);
  const [justUploaded, setJustUploaded] = useState(false);

  const fileInputRef = useRef(null);
  const [username, setUsername] = useState('');

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const usernameParam = params.get("username");

  const fetchUserDetails = (uname) => {
    UserService.getUserDetails(uname)
      .then((data) => {
        const userData = data.data?.users[0];
        setUser(userData);
        setEmailId(userData.emailId);
        setPhoneNumber(userData.phoneNumber);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (usernameParam) {
      setUsername(usernameParam);
      fetchUserDetails(usernameParam);
    } else {
      const decoded = decodeJWT(localStorage.getItem('authToken'));
      const uname = decoded?.username;
      if (!uname) {
        console.error('No username found in token');
        return;
      }
      setUsername(uname);
      fetchUserDetails(uname);
    }
  }, [usernameParam]);

  useEffect(() => {
    if (!user?.dpPath) {
      setProfilePicUrl(userProfileImg);
      return;
    }

    const fetchUserImage = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const url = `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${encodeURIComponent(
          user.dpPath
        )}&t=${Date.now()}`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        });
        const imageBlob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        setProfilePicUrl(URL.createObjectURL(imageBlob));
      } catch (error) {
        console.error("Error fetching user profile image:", error);
        setProfilePicUrl(userProfileImg);
      }
    };

    fetchUserImage();
  }, [user?.dpPath]);

  const decoded = decodeJWT(localStorage.getItem("authToken"));
  const loggedInUser = decoded?.username;

  const canEdit =
    user?.username === loggedInUser ||
    decoded?.roles?.includes("ADMIN") ||
    decoded?.roles?.includes("TL");

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    if (user.username === loggedInUser) {
      setProfileImageUrl(previewUrl);
    } else {
      setProfilePicUrl(previewUrl);
    }

    try {
      setLoading(true);
      await UserService.uploadUserDp(user.username, file);
      fetchUserDetails(user.username);
    } catch (error) {
      console.error("Failed to upload profile picture", error);
      if (user.username === loggedInUser) setProfileImageUrl(userProfileImg);
      else setProfilePicUrl(userProfileImg);
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  };

  const handleDeleteDp = async () => {
    if (!user?.dpPath) {
      console.warn("No profile picture to delete");
      return;
    }
    try {
      setLoading(true);
      await UserService.deleteUserDp(user.username, user.dpPath);
      if (user.username === loggedInUser) setProfileImageUrl(userProfileImg);
      else setProfilePicUrl(userProfileImg);
      fetchUserDetails(user.username);
    } catch (error) {
      console.error("Failed to delete profile picture", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadClick = () => fileInputRef.current.click();


  const saveUser = (event) => {
    let updatedUser = { ...user };
    switch (event.target.id) {
      case 'emailId':
        updatedUser.emailId = emailId;
        setEditState({ ...editState, emailId: false });
        break;
      case 'phoneNumber':
        updatedUser.phoneNumber = phoneNumber;
        setEditState({ ...editState, phoneNumber: false });
        break;
    }
    UserService.updateUserDetails(updatedUser);
  };

  return (
    <Container fluid>
      <Card style={{ backgroundColor: '#FFFFFF' }}>
        <Card.Body>
          <Row>
            <Col className="justify-content-center  d-flex">
              <h3 style={{ fontSize: '24px', fontWeight: '600', marginTop: '20px' }}>User Profile</h3>
            </Col>
          </Row>

          <Row>
            <Col className="d-flex justify-content-center">
              <div className="rounded-circle overflow-hidden position-relative profile-pic-container mt-2">
                <Image
                  src={user.username === loggedInUser ? profileImageUrl : profilePicUrl}
                  width={160}
                  height={160}
                  alt="Profile"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </Col>
          </Row>

          {canEdit && (
            <Row className="mt-3 justify-content-center">
              <Col xs="auto">
                <Button variant="primary" onClick={handleUploadClick}>
                  Upload
                </Button>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </Col>
              <Col xs="auto">
                <Button
                  variant="danger"
                  onClick={handleDeleteDp}
                  disabled={!user?.dpPath}
                >
                  Delete
                </Button>
              </Col>
            </Row>
          )}


          <div className="ms-auto me-auto pt-4" style={{ width: '425px' }}>
            <Row>
              <Col>
                <Row><Col><span className="profile-label">Name</span></Col></Row>
                <Row><Col><span className="profile-field">{user.firstName} {user.lastName}</span></Col></Row>
              </Col>
              <Col>
                <Row><Col><span className="profile-label">Role</span></Col></Row>
                <Row><Col><span className="profile-field">{user.roles?.join(',')}</span></Col></Row>
              </Col>
              <Col>
                <Row><Col><span className="profile-label">User ID</span></Col></Row>
                <Row><Col><span className="profile-field">{user.username}</span></Col></Row>
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
      <Card style={{ marginTop: 20, backgroundColor: '#FFFFFF' }}>
        <Card.Body>
          <h5 className="profile-header"> Personal Information</h5>
          <Row>
            <Col>
              <Row><Col><span className="profile-personal-info-label">Email ID</span></Col></Row>
              <Row><Col><span className="profile-field">{emailId}</span></Col></Row>
            </Col>
            <Col>
              <Row><Col><span className="profile-personal-info-label">Mobile Number</span></Col></Row>
              <Row><Col><span className="profile-field">{phoneNumber}</span></Col></Row>
            </Col>
            {/* <Col>
              <Row><Col><span className="profile-personal-info-label">Location</span></Col></Row>
              <Row><Col><span className="profile-field">{user.username}</span></Col></Row>
            </Col> */}
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};